import { Directive, ViewContainerRef } from "@angular/core";

@Directive({})
export abstract class ViewContainerRefDir {
    constructor(public viewContainerRef: ViewContainerRef) { }
}